































import Vue from 'vue';
import _ from 'lodash';

interface Data {
  initialValue: number|string,
}

export default Vue.extend({
  props: {
    value: {
      type: [Number, String],
      default: 10,
    },
    max: {
      type: Number,
      required: true,
    },
    fixedWidth: {
      type: Boolean,
      default: true,
    },
  },
  data(): Data {
    return {
      initialValue: this.value,
    };
  },
  computed: {
    canFilter(): boolean {
      if (_.isString(this.initialValue)) {
        return (parseInt(this.initialValue, 10) !== this.max);
      }
      return (this.initialValue !== this.max);
    },
    filterText(): string {
      return (this.isMax) ? 'View Less' : 'View All';
    },
    isMax(): boolean {
      return (this.value >= this.max);
    },
    maxLength(): number {
      return this.max.toString().length;
    },
  },
  methods: {
    change(value): void {
      let val = parseInt(value, 10);
      if (val < 1) {
        val = 1;
      } else if (val > this.max) {
        val = this.max;
      }
      this.$emit('input', val);
    },
    filter(): void {
      if (this.isMax) {
        this.$emit('input', this.initialValue);
      } else {
        this.$emit('input', this.max);
      }
    },
  },
  created(): void {
    if (this.value > this.max) {
      this.initialValue = this.max;
      this.$emit('input', this.max);
    }
  },
});
